import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Stop({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Stop</title>
      <path
        d="M4 8.26667C4 6.77319 4 6.02646 4.29065 5.45603C4.54631 4.95426 4.95426 4.54631 5.45603 4.29065C6.02646 4 6.77319 4 8.26667 4H15.7333C17.2268 4 17.9735 4 18.544 4.29065C19.0457 4.54631 19.4537 4.95426 19.7094 5.45603C20 6.02646 20 6.77319 20 8.26667V15.7333C20 17.2268 20 17.9735 19.7094 18.544C19.4537 19.0457 19.0457 19.4537 18.544 19.7094C17.9735 20 17.2268 20 15.7333 20H8.26667C6.77319 20 6.02646 20 5.45603 19.7094C4.95426 19.4537 4.54631 19.0457 4.29065 18.544C4 17.9735 4 17.2268 4 15.7333V8.26667Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
